import { IoPeopleOutline } from 'react-icons/io5';
import {
  TbWallet,
  TbCloudUpload,
  TbUsersGroup,
  TbChartPie,
  TbFolder,
  TbMessageCircle,
  TbHeadphones,
  TbFileText,
} from 'react-icons/tb';

/** Product catalog for the public /products page. */
export const PRODUCT_CATEGORIES = [
  {
    id: 'community',
    title: 'Community & social',
    shortTitle: 'Social',
    tagline: 'Where conversations turn into connection.',
    icon: TbUsersGroup,
    products: [
      {
        id: 'social-network',
        name: 'Social network',
        description:
          'Discussions, clubs, stories, and profiles — one place to meet, share, and grow with your community.',
        icon: IoPeopleOutline,
        accent: 'community',
        path: '/posts',
        auth: 'guest',
        cta: 'Open feed',
      },
    ],
  },
  {
    id: 'messages',
    title: 'Messages',
    shortTitle: 'Messages',
    tagline: 'Private conversations, without the feed.',
    icon: TbMessageCircle,
    products: [
      {
        id: 'direct-messages',
        name: 'Messages',
        description:
          'Private inbox and conversations only — no posts, feed, or social network. Use the same account as our other apps.',
        icon: TbMessageCircle,
        accent: 'messages',
        path: '/messages',
        auth: 'signin',
        cta: 'Open Messages',
      },
    ],
  },
  {
    id: 'finance',
    title: 'Finance & operations',
    shortTitle: 'Finance',
    tagline: 'Stay on top of shared spending and budgets.',
    icon: TbChartPie,
    products: [
      {
        id: 'expense-management',
        name: 'Expense management',
        description:
          'Track group expenses, split costs, and review spend with clear budgets — built for households, teams, and projects.',
        icon: TbWallet,
        accent: 'finance',
        path: '/costing/cashflow',
        auth: 'signin',
        cta: 'Open Cashflow',
      },
    ],
  },
  {
    id: 'storage',
    title: 'Files & storage',
    shortTitle: 'Storage',
    tagline: 'Your files, organized and within reach.',
    icon: TbFolder,
    products: [
      {
        id: 'storage-box',
        name: 'Storage Box',
        description:
          'Secure cloud storage with folders, sharing, previews, and optional locked spaces — keep documents and media in one workspace.',
        icon: TbCloudUpload,
        accent: 'storage',
        path: '/storagebox',
        auth: 'signin',
        cta: 'Open Storage Box',
      },
    ],
  },
  {
    id: 'writing',
    title: 'Writing & docs',
    shortTitle: 'Writing',
    tagline: 'Draft, format, and export from the browser.',
    icon: TbFileText,
    products: [
      {
        id: 'text-editor',
        name: 'Text Editor',
        description:
          'Rich text and markdown with tables, print layout, and PDF export — save drafts on this device or edit files in Storage Box.',
        icon: TbFileText,
        accent: 'writing',
        path: '/text-editor',
        auth: 'guest',
        cta: 'Open editor',
      },
    ],
  },
  {
    id: 'media',
    title: 'Media & playback',
    shortTitle: 'Media',
    tagline: 'Listen anywhere — online or offline.',
    icon: TbHeadphones,
    products: [
      {
        id: 'audio-player',
        name: 'Audio Player',
        description:
          'Play mp3, wav, podcasts, and more with an equalizer, 10-second skip, loop, offline downloads, and direct streaming from Storage Box.',
        icon: TbHeadphones,
        accent: 'media',
        path: '/audio-player',
        auth: 'guest',
        cta: 'Open player',
      },
    ],
  },
];
